import { isSinkLaborProduct, isSinkProduct } from '~/core/helpers';
import { DrawingShape, ProductQty } from '~/core/models';
import { isEqApplianceId } from '~/core/utils';

export const findAppliedApplianceName = (
  applianceId: string,
  shapes: DrawingShape[]
): string => {
  const appliance = shapes
    .map((shape) => shape.appliances)
    .flat()
    .find(isEqApplianceId(applianceId));

  return (
    appliance?.applianceModel?.consumerDesc ??
    appliance?.applianceModel?.name ??
    ''
  );
};

export const getPricedSinksFromDrawingShapes = (
  drawingShapes: DrawingShape[]
): ProductQty[] => {
  const appliances = drawingShapes.reduce(
    (acc, next) => {
      next.appliances
        .filter(
          (appliance) =>
            isSinkLaborProduct(appliance.applianceModel) ||
            isSinkProduct(appliance.applianceModel)
        )
        .forEach((appliance) => {
          const {
            applianceModel: { productId },
          } = appliance;

          acc[productId] = (acc[productId] ?? 0) + 1;
        });

      return acc;
    },
    [] as Record<number, number>
  );

  return Object.entries(appliances).map(([productId, quantity]) => ({
    productId: Number(productId),
    quantity,
  }));
};
